import React, { Component } from "react";
import Sad from "../../assets/images/other-images/sad.png";
export default class ForbiddenPage extends Component {
    render() {
        return (
            <>
                <div className="tap-top"><i data-feather="chevrons-up"></i></div>
                <div className="page-wrapper compact-wrapper" id="pageWrapper">
                    <div className="error-wrapper">
                        <div className="container"><img className="img-100" src={Sad} alt=""/>
                            <div className="error-heading">
                                <h2 className="headline font-danger">403</h2>
                            </div>
                            <div className="col-md-8 offset-md-2">
                                <p className="sub-content">Desculpe mais não foi possível localizar a página</p>
                            </div>
                            <div><a className="btn btn-danger-gradien btn-lg" href="/">Voltar ao Menu</a></div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}